import { Loader2, Sparkles, Check, X } from "lucide-react";
import { AiNote } from "./WizardItem";

// KI-Gesamtauswertung + Sammelliste aller Vorschläge (Übersicht).
export default function AiPanel({ steps, doc, aiRunning, onRunFull, onAiDecide, onJump }) {
  const sugg = doc?.ai_suggestions || {};
  const remarks = doc?.ai_remarks || [];
  const job = doc?.ai_job;
  const items = [];
  steps.forEach((sec, i) => sec.fields.forEach((f) => { if (sugg[f.key]) items.push({ f, i, s: sugg[f.key] }); }));

  return (
    <div className="rounded-2xl border border-amber-400/40 bg-amber-400/[0.04] p-4 space-y-3" data-testid="wizard-ai-panel">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="min-w-0">
          <div className="text-[15px] font-bold text-amber-100 inline-flex items-center gap-1.5"><Sparkles size={15} /> KI-Assistent</div>
          <div className="text-[12.5px] text-zinc-400 mt-0.5">
            Wertet alle Fotos, Maße und Projektdaten aus und schlägt Werte für offene Felder vor. Nichts wird automatisch eingetragen.
          </div>
        </div>
        <button type="button" onClick={onRunFull} disabled={aiRunning} data-testid="wizard-ai-full-btn"
                className="h-11 px-4 rounded-xl bg-amber-400 text-zinc-950 text-[13.5px] font-bold inline-flex items-center gap-1.5 disabled:opacity-60">
          {aiRunning ? <Loader2 size={15} className="animate-spin" /> : <Sparkles size={15} />}
          {aiRunning ? "KI wertet aus …" : "KI-Vorschläge für den ganzen V-Check"}
        </button>
      </div>
      {job?.status === "error" && <div className="text-[12.5px] text-red-300" data-testid="wizard-ai-error">{job.error}</div>}
      {job?.status === "done" && !aiRunning && items.length === 0 && remarks.length === 0 && (
        <div className="text-[12.5px] text-zinc-400" data-testid="wizard-ai-empty">Keine neuen Vorschläge – mehr Fotos helfen der KI.</div>
      )}

      {items.length > 0 && (
        <div className="space-y-2" data-testid="wizard-ai-list">
          <div className="flex items-center justify-between gap-2 flex-wrap">
            <div className="text-[13px] font-semibold text-zinc-200">{items.length} Vorschläge</div>
            <div className="flex gap-2 w-full sm:w-auto [&>button]:flex-1 sm:[&>button]:flex-none [&>button]:justify-center">
              <button type="button" onClick={() => onAiDecide(items.map((x) => x.f.key), true)} data-testid="wizard-ai-accept-all"
                      className="h-9 px-3 rounded-lg bg-emerald-500 text-zinc-950 text-[12.5px] font-bold inline-flex items-center gap-1"><Check size={13} /> Alle übernehmen</button>
              <button type="button" onClick={() => onAiDecide(items.map((x) => x.f.key), false)} data-testid="wizard-ai-reject-all"
                      className="h-9 px-3 rounded-lg bg-zinc-800 text-zinc-200 text-[12.5px] font-semibold inline-flex items-center gap-1"><X size={13} /> Alle verwerfen</button>
            </div>
          </div>
          {items.map(({ f, i, s }) => (
            <div key={f.key}>
              <button type="button" onClick={() => onJump(i, f.key)} className="text-[11.5px] text-zinc-500 underline-offset-2 hover:underline mb-1">
                Abschnitt {steps[i].section} · {steps[i].title}
              </button>
              <AiNote fieldKey={`list-${f.key}`} label={f.label} suggestion={s} onDecide={(accept) => onAiDecide([f.key], accept)} />
            </div>
          ))}
        </div>
      )}

      {remarks.length > 0 && (
        <div className="rounded-lg border border-amber-400/40 bg-zinc-900/60 p-3 space-y-2" data-testid="wizard-ai-remarks">
          <div className="text-[13px] font-semibold text-amber-100">Fachliche Hinweise der KI</div>
          <ul className="list-disc pl-5 space-y-1 text-[13px] text-zinc-300">
            {remarks.map((r, i) => <li key={i}>{r}</li>)}
          </ul>
          <div className="flex gap-2">
            <button type="button" onClick={() => onAiDecide([], true, true)} data-testid="wizard-ai-remarks-accept"
                    className="flex-1 h-9 rounded-lg bg-emerald-500 text-zinc-950 text-[12.5px] font-bold">In „Offene Punkte“ übernehmen</button>
            <button type="button" onClick={() => onAiDecide([], false, true)} data-testid="wizard-ai-remarks-reject"
                    className="flex-1 h-9 rounded-lg bg-zinc-800 text-zinc-200 text-[12.5px] font-semibold">Verwerfen</button>
          </div>
        </div>
      )}
    </div>
  );
}
